// extracted by mini-css-extract-plugin
module.exports = {"searchIconWrapper":"_92430752"};